import { app } from '../index'
import combine from '../services/combine-service'

const custinfo = {
  customers: [],
  locations: [],
  engassigned: [],
  billing: [],
  programs: [],
  salarycodes: [],
  complete: false
}

// service + " - " + reducer
export default function (state = custinfo, action) {
  let newstuff = action.payload
  switch (action.type) {
    case 'customers - custreducer':
      return { ...state, customers: action.payload }

      break
    case 'billing - custreducer':
      return { ...state, billing: action.payload }

      break
    case 'location - custreducer':
      return { ...state, locations: action.payload }
      break
    case 'salarycodes - custreducer':
      return { ...state, salarycodes: action.payload }

      break
    case 'engassigned - custreducer':
      return { ...state, engassigned: action.payload }

      break
    case 'programs - custreducer':
      return { ...state, programs: action.payload }

      break
    case 'Update > customers':
      return {
        ...state,
        customers: combine(
          state.customers,
          action.payload,
          'custnumber',
          action.deletestatus
        )
      }
      break
    case 'Update > billing':
      return {
        ...state,
        billing: combine(
          state.billing,
          action.payload,
          'id',
          action.deletestatus
        )
      }
      break
    case 'Update > location':
      return {
        ...state,
        location: combine(
          state.locations,
          action.payload,
          'custnumber',
          action.deletestatus
        )
      }
      break
    case 'Update > engassigned':
      return {
        ...state,
        engassigned: combine(
          state.engassigned,
          action.payload,
          'defnumber',
          action.deletestatus
        )
      }
      break
    default: {
      return { ...state }
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/cust-reducer.js